import ErrorBase from "./ErrorBase";

export interface APIError {
  errors?: {
    status: string;
    title: string;
    detail?: string;
    source?: { pointer?: string; parameter?: string; header?: string };
  }[];
}

export class ServerError extends ErrorBase {
  constructor(serverData?: APIError) {
    const { title, detail } = ServerError.parseError(serverData);

    super({
      name: "ServerError",
      title: title,
      message: detail,
      icon: "/images/server_warning.svg",
    });
    Object.setPrototypeOf(this, ServerError.prototype);
  }

  /**
   * Parse the server response to extract error details.
   */
  private static parseError(serverData?: APIError): {
    title: string;
    detail: string;
  } {
    if (
      !serverData?.errors ||
      !Array.isArray(serverData.errors) ||
      serverData.errors.length === 0
    ) {
      return { title: "error", detail: "error_somethingWentWrong" };
    }

    if (ServerError.isValidationErrorResponse(serverData)) {
      const details = serverData.errors.map(
        (error) => error.detail || "error_somethingWentWrong"
      );
      return {
        title: "error_validation_title",
        detail: details.join("\n"), // Concatenate all error details into a single string
      };
    }

    // For other error types, return the first error's title and detail
    const errorItem = serverData.errors[0];
    return {
      title: errorItem.title,
      detail: errorItem.detail || "error_somethingWentWrong",
    };
  }

  /**
   * Check if the server response is a validation error response.
   */
  private static isValidationErrorResponse(serverData: APIError) {
    return serverData.errors?.[0]?.status === "422";
  }
}
